/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Badge } from '@/components/ui/badge';

export const BODY_REGIONS = [
  ['sacrum', 'Sacro'], ['heel', 'Tallone'], ['trochanter', 'Trocantere'], ['ischial', 'Ischio'],
  ['malleolus', 'Malleolo'], ['back', 'Dorso'], ['foot', 'Piede'], ['lower_leg', 'Gamba'],
  ['arm', 'Braccio'], ['hand', 'Mano'], ['abdomen', 'Addome'], ['other', 'Altro'],
];
export const WOUND_TYPES = [
  ['pressure_ulcer', 'Lesione da pressione'], ['venous_ulcer', 'Ulcera venosa'],
  ['arterial_ulcer', 'Ulcera arteriosa'], ['diabetic_ulcer', 'Ulcera diabetica'],
  ['surgical', 'Chirurgica'], ['traumatic', 'Traumatica'], ['burn', 'Ustione'], ['other', 'Altro'],
];

export const StageBadge = ({ stage }) => {
  const map = {
    I: { c: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
    II: { c: 'bg-amber-100 text-amber-800 border-amber-200' },
    III: { c: 'bg-orange-100 text-orange-800 border-orange-200' },
    IV: { c: 'bg-red-100 text-red-800 border-red-200' },
    DTPI: { c: 'bg-purple-100 text-purple-800 border-purple-200' },
    Unstageable: { c: 'bg-slate-100 text-slate-800 border-slate-200' },
  };
  const s = map[stage] || { c: 'bg-slate-100 text-slate-800 border-slate-200' };
  return <Badge variant="outline" className={`text-[10px] ${s.c}`}>Stadio {stage}</Badge>;
};
